'use strict';

/**
 * Remove all validation. Should be called every time before revalidating form
 * @param {element} form - Form to be cleared
 * @returns {void}
 */
function clearFormErrors(form) {
    $(form).find('.form-control.is-invalid').removeClass('is-invalid');
}

module.exports = function (formElement, payload) {
    // clear form validation first
    clearFormErrors(formElement);
    $('.alert', formElement).remove();
    
    if (typeof payload === 'object' && payload.fields) {
        var i = 1;
        Object.keys(payload.fields).forEach(function (key) {
            if (payload.fields[key]) {
                var feedbackElement = $(formElement).find('[name="' + key + '"]')
                    .parent()
                    .children('.invalid-feedback');
                if (i === 1) {
                    var focusElement = $(formElement).find('[name="' + key + '"]');
                    /* The actual viewport of the page starts from below of the header because the header position is fixed, so by calculating
                    the header height and adding an extra 30 pixels, you will get the perfect position for displaying the focused element.*/
                    var scrollPosition = $('.header-main').height() + 30;
                    // To find the current position of focused element
                    var focuselementPosition = focusElement.offset().top - $(window).scrollTop();
                    // To check whether the focused element is in the viewport or not
                    if (focuselementPosition < scrollPosition) {
                        // To scroll down the focused element to the calculated position.
                        $('html, body').animate({
                            scrollTop: focusElement.offset().top - scrollPosition
                        }, 500);
                    }
                    focusElement.focus();
                }

                if (feedbackElement.length > 0) {
                    if (Array.isArray(payload[key])) {
                        feedbackElement.html(payload.fields[key].join('<br/>'));
                    } else {
                        feedbackElement.html(payload.fields[key]);
                    }
                    feedbackElement.siblings('.form-control').addClass('is-invalid');
                }
            }
            i++;
        });
    }
    if (payload && payload.error) {
        var form = $(formElement).prop('tagName') === 'FORM'
            ? $(formElement)
            : $(formElement).parents('form');

        form.prepend('<div class="alert alert-danger" role="alert">'
            + payload.error.join('<br/>') + '</div>');
    }
};
